import Icon from '../components/Icon.vue'

Icon.register({"file":{"width":1536,"height":1792,"paths":[{"d":"M1024 512v-472q22 14 36 28l408 408q14 14 28 36h-472zM896 544q0 40 28 68t68 28h544v1056q0 40-28 68t-68 28h-1344q-40 0-68-28t-28-68v-1600q0-40 28-68t68-28h800v544z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/file.js
// module id = 756
// module chunks = 0